import React from "react";
import { formatCurrency } from "../../../shared/utils";
import { useBudget } from "../hooks/useBudget";
import { Box, CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Collapse, IconButton } from "@mui/material";
import {
    KeyboardArrowDown as KeyboardArrowDownIcon,
    KeyboardArrowRight as KeyboardArrowRightIcon
} from "@mui/icons-material";

const Row = ({ row, subRows }: { row: any, subRows: any[] }) => {

    const [open, setOpen] = React.useState(false);

    return (
        <>
            <TableRow>
                <TableCell>
                    <IconButton size="small" onClick={() => setOpen(!open)} disabled={subRows.length === 0}>
                        {open ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
                    </IconButton>
                    {row.name}
                </TableCell>
                <TableCell>{row.type}</TableCell>
                <TableCell>{row.budget_ref}</TableCell>
                <TableCell>{row.phase_id}</TableCell>
                <TableCell>{row.created_by}</TableCell>
                <TableCell>{row.status}</TableCell>
                <TableCell>{formatCurrency(row.baseline)}</TableCell>
            </TableRow>
            {subRows && (
                <TableRow style={{ borderBottom: 'none' }}>
                    <TableCell style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 40 }} colSpan={8}>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            <Table>
                                <TableBody sx={{ paddingLeft: '0px' }}>
                                    {
                                        subRows.length === 0 ?
                                            <TableRow>
                                                <TableCell
                                                    colSpan={7}
                                                    sx={{ textAlign: 'center', py: 4 }}
                                                >
                                                    No data available
                                                </TableCell>
                                            </TableRow>
                                            :
                                            subRows.map((sub: any) => (
                                                <TableRow sx={{ paddingLeft: '0px' }} key={sub.id}>
                                                    <TableCell>{sub.name}</TableCell>
                                                    <TableCell>{sub.type}</TableCell>
                                                    <TableCell>{sub.budget_ref}</TableCell>
                                                    <TableCell>{sub.phase_id}</TableCell>
                                                    <TableCell>{sub.created_by}</TableCell>
                                                    <TableCell>{sub.status}</TableCell>
                                                    <TableCell>{formatCurrency(sub.baseline)}</TableCell>
                                                </TableRow>
                                            ))}
                                </TableBody>
                            </Table>
                        </Collapse>
                    </TableCell>
                </TableRow>
            )}
        </>
    );
};

export const BudgetTable: React.FC<{ projectId: string | undefined }> = ({ projectId }) => {

    const { data, isLoading } = useBudget(projectId);

    const headers = [
        { alias_name: "name", label: "Name", display_order: 1, is_show: true },
        { alias_name: "type", label: "Type", display_order: 2, is_show: true },
        { alias_name: "budget_ref", label: "Budget Ref", display_order: 3, is_show: true },
        { alias_name: "status", label: "Status", display_order: 5, is_show: true },
        { alias_name: "phase_id", label: "Phase ID", display_order: 6, is_show: true },
        { alias_name: "created_by", label: "Created By", display_order: 7, is_show: true },
        { alias_name: "baseline", label: "Baseline", display_order: 8, is_show: true },
    ];

    if (isLoading) {
        return (
            <Box
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                width="100%"
                gap={2}
            >
                <CircularProgress />
            </Box>
        )
    };

    return (
        <Box flex={1} height={'100%'} display={'flex'} flexDirection={'column'}>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            {
                                headers.sort((a, b) => a.display_order - b.display_order).map((header) => (
                                    <TableCell key={header.label}>{header.label}</TableCell>
                                ))
                            }
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            data.length === 0 ?
                                <TableRow>
                                    <TableCell
                                        colSpan={headers.length}
                                        sx={{ textAlign: 'center', py: 4 }}
                                    >
                                        No data available
                                    </TableCell>
                                </TableRow> :
                                data.map((row: any, index: React.Key | null | undefined) => (
                                    row.parent_id === null &&
                                    <Row key={index} row={row} subRows={data.filter((rowData: { parent_id: string; }) => rowData.parent_id === '2').reverse()} />
                                ))
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};